module.exports = __webpack_public_path__ + "static/media/mssg_getstartedresponse_en_US.f7d3b1f6.PNG";